import { render } from "./FormRadio.vue?vue&type=template&id=7243f678&scoped=true"
import script from "./FormRadio.vue?vue&type=script&lang=js"
export * from "./FormRadio.vue?vue&type=script&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=7243f678&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243f678"]])

export default __exports__